var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 379.308,
    height: 118.53,
    viewBox: "0 0 379.308 118.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.051,
    y1: 0.44,
    x2: 1,
    y2: 0.404,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#2db6bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#59be89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#79c465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#8cc74f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94c947"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724",
    transform: "translate(-72.403 -80.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(212.647 93.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M88.2,25.363l-4.3-11.785L79.63,25.363Zm1.085,2.966H78.525l-1.938,5.35H73.214l8.916-23.9h3.586l8.916,23.9H91.259l-1.938-5.35Z",
    transform: "translate(-73.195 -9.372)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M84.973,25.663V9.789h3.179V25.528c0,3.314,1.977,5.485,5.8,5.485s5.8-2.19,5.8-5.485V9.789h3.14V25.663c0,5.195-3.721,8.47-8.955,8.47s-8.974-3.276-8.974-8.47",
    transform: "translate(-62.18 -9.363)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M95.753,28.467l2.733-1.57c.853,2.636,2.907,4.342,6.377,4.342s5.059-1.531,5.059-3.683c0-2.462-2.113-3.276-5.64-4.361-3.818-1.221-7.52-2.423-7.52-6.861s3.508-6.764,7.52-6.764a8.47,8.47,0,0,1,8.083,5.214l-2.655,1.531a5.544,5.544,0,0,0-5.427-3.683c-2.558,0-4.342,1.357-4.342,3.547s1.667,3.043,5.02,4.09c4.167,1.357,8.083,2.6,8.083,7.21,0,4.206-3.373,6.861-8.257,6.861-4.535,0-7.772-2.287-9.052-5.873",
    transform: "translate(-52.065 -9.569)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M122.515,12.793H115.44V33.687H112.3V12.793h-7.036v-3h17.25Z",
    transform: "translate(-43.123 -9.363)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M118.613,21.67h6.377a4.376,4.376,0,0,0,4.264-4.477,4.354,4.354,0,0,0-4.264-4.439h-6.377Zm5.64,2.869h-5.64v9.149h-3.179V9.789h9.556a7.379,7.379,0,0,1,2.5,14.343l5.64,9.556h-3.508Z",
    transform: "translate(-33.582 -9.363)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M140.287,25.363l-4.3-11.785L131.72,25.363Zm1.085,2.966H130.615l-1.938,5.35H125.3l8.916-23.9h3.586l8.916,23.9h-3.373l-1.938-5.35Z",
    transform: "translate(-24.321 -9.372)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M151.044,30.683v3h-13.49V9.789h3.179V30.683Z",
    transform: "translate(-12.827 -9.363)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 3.179,
    height: 23.899,
    transform: "translate(140.698 0.426)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M163.607,25.363l-4.3-11.785L155.04,25.363Zm1.085,2.966H153.935L152,33.678h-3.373l8.916-23.9h3.586l8.916,23.9h-3.373l-1.938-5.35Z",
    transform: "translate(-2.441 -9.372)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M178.9,9.789v23.9h-2.559L164.053,15.836V33.687h-3.179V9.789h2.558l12.289,17.832V9.789Z",
    transform: "translate(9.053 -9.363)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M76.383,36.88H82.76a4.462,4.462,0,0,0,0-8.916H76.383Zm5.64,2.869h-5.64V48.9H73.2V25H82.76a7.379,7.379,0,0,1,2.5,14.343L90.9,48.9H87.392l-5.369-9.149",
    transform: "translate(-73.204 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M98.18,45.893v3H83.914V25h14.11v3H87.093v7.346H97.172v2.966H87.093v7.579Z",
    transform: "translate(-63.155 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M96.193,28v7.753H106.33v3H96.193V48.9H93.014V25h13.762v3Z",
    transform: "translate(-54.617 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M104.843,36.88h6.377a4.462,4.462,0,0,0,0-8.916h-6.377Zm5.64,2.869h-5.64V48.9h-3.179V25h9.556a7.379,7.379,0,0,1,2.5,14.343l5.64,9.556h-3.508l-5.369-9.149",
    transform: "translate(-46.501 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 3.179,
    height: 23.899,
    transform: "translate(75.902 29.907)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M140.14,38.7c0,6.086-4.516,10.854-11.707,10.854a12.387,12.387,0,1,1-.078-24.771,11.892,11.892,0,0,1,10.35,5.776l-2.733,1.609a8.558,8.558,0,0,0-7.656-4.3,9.075,9.075,0,0,0-9.362,9.323,9.057,9.057,0,0,0,9.5,9.284c4.943,0,7.889-2.733,8.509-6.319h-8.78V37.281h11.94v1.434Z",
    transform: "translate(-33.206 4.702)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M144.45,45.893v3H130.184V25h14.091v3H133.344v7.346h10.079v2.966H133.344v7.579Z",
    transform: "translate(-19.742 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M142.453,36.88h6.377a4.462,4.462,0,0,0,0-8.916h-6.377Zm5.64,2.869h-5.64V48.9h-3.179V25h9.556a7.379,7.379,0,0,1,2.5,14.343l5.64,9.556h-3.508Z",
    transform: "translate(-11.214 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M164.117,40.573l-4.3-11.785L155.55,40.573Zm1.085,2.966H154.445l-1.938,5.35h-3.373l8.916-23.9h3.586l8.916,23.9h-3.373l-1.938-5.35Z",
    transform: "translate(-1.963 4.899)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M176.225,28H169.17V48.9h-3.14V28h-7.036V25h17.231Z",
    transform: "translate(7.289 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 3.179,
    height: 23.899,
    transform: "translate(185.995 29.907)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M194.207,37.164a9.227,9.227,0,1,0-18.452,0,9.226,9.226,0,1,0,18.452,0m-21.573,0A12.376,12.376,0,1,1,185,49.55a12.269,12.269,0,0,1-12.366-12.385",
    transform: "translate(20.086 4.702)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M205.27,25V48.9h-2.559L190.423,31.046V48.9h-3.179V25H189.8l12.289,17.813V25Z",
    transform: "translate(33.794 4.908)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M73.214,52.364a12.159,12.159,0,0,1,12.5-12.385,11.822,11.822,0,0,1,10.311,5.8l-2.772,1.609a8.385,8.385,0,0,0-7.54-4.342,9.02,9.02,0,0,0-9.362,9.323,8.989,8.989,0,0,0,9.362,9.284,8.428,8.428,0,0,0,7.54-4.3l2.772,1.57A11.762,11.762,0,0,1,85.716,64.75a12.182,12.182,0,0,1-12.5-12.385",
    transform: "translate(-73.195 18.963)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M107.307,52.364a9.226,9.226,0,1,0-9.226,9.284,9.124,9.124,0,0,0,9.226-9.284m-21.573,0A12.376,12.376,0,1,1,98.1,64.75,12.269,12.269,0,0,1,85.734,52.364",
    transform: "translate(-61.448 18.963)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M100.223,56.083V40.209H103.4V55.948c0,3.314,1.977,5.485,5.8,5.485s5.8-2.19,5.8-5.485V40.209h3.14V56.083c0,5.195-3.721,8.47-8.955,8.47s-8.974-3.276-8.974-8.47",
    transform: "translate(-47.871 19.179)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M129.95,40.209v23.9h-2.558L115.1,46.256V64.107h-3.179v-23.9h2.558l12.289,17.813V40.209Z",
    transform: "translate(-36.875 19.179)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M123.094,52.364a12.159,12.159,0,0,1,12.5-12.385,11.822,11.822,0,0,1,10.311,5.8l-2.772,1.609a8.385,8.385,0,0,0-7.54-4.342,9.02,9.02,0,0,0-9.362,9.323,8.989,8.989,0,0,0,9.362,9.284,8.428,8.428,0,0,0,7.54-4.3l2.772,1.57A11.762,11.762,0,0,1,135.6,64.75a12.182,12.182,0,0,1-12.5-12.385",
    transform: "translate(-26.395 18.963)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 3.179,
    height: 23.899,
    transform: "translate(122.711 59.388)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M154.164,61.1v3h-13.49v-23.9h3.179V61.1Z",
    transform: "translate(-9.9 19.179)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M88.6,108.5l10.777,12.851h.1l6.261-12.851ZM49.238,76.921l-2.733,9.2,14.905-5.464.039-10.74ZM82.293,23.827,71.129,8.67H45.058L.848,47.008,8.33,100.736,40.621,88.855l2.326-7.85L32.5,87a2.353,2.353,0,0,1-1.182.308,2.32,2.32,0,0,1-2.053-1.2,2.357,2.357,0,0,1,.892-3.237L40.6,76.879l-11.61-2.871a2.377,2.377,0,0,1-1.746-2.867,2.4,2.4,0,0,1,2.89-1.744l16.436,4.049,12.211-7L46.628,59.374,30.154,63.311a3.067,3.067,0,0,1-.562.056,2.377,2.377,0,0,1-.543-4.691L40.66,55.9,30.249,49.84a2.382,2.382,0,0,1,2.405-4.111L43.063,51.8,39.749,40.321A2.38,2.38,0,1,1,44.323,39l4.71,16.264L61.186,62.34l.058-14.07L49.593,35.979a2.373,2.373,0,0,1,3.452-3.256l8.218,8.664L61.3,29.351a2.375,2.375,0,0,1,4.751.019L66.01,41.407,74.288,32.8a2.385,2.385,0,0,1,3.45,3.3L66.01,48.307l-.056,14.072L78.165,55.4l4.826-16.243a2.376,2.376,0,1,1,4.555,1.357L84.133,51.97l10.449-5.989a2.379,2.379,0,0,1,2.365,4.128L86.5,56.1l11.589,2.869a2.385,2.385,0,0,1,1.744,2.888,2.351,2.351,0,0,1-2.3,1.8,1.814,1.814,0,0,1-.562-.078L80.53,59.529l-12.211,7L80.469,73.6l16.477-3.937a2.382,2.382,0,0,1,1.1,4.634l-11.61,2.772L96.85,83.137a2.383,2.383,0,0,1-1.223,4.439,2.195,2.195,0,0,1-1.182-.33L84.038,81.179l3.314,11.474a2.381,2.381,0,0,1-1.63,2.946,2.592,2.592,0,0,1-.676.1,2.354,2.354,0,0,1-2.268-1.723L78.068,77.71,65.915,70.637l-.039,13.314,18.974,20.08h22.621l18.161-32.7L97.993,2.816Z",
    transform: "translate(71.555 78.092)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArc);
export default __webpack_public_path__ + "static/media/ARC.533dc4fe119a906cea430183f3a83aed.svg";
export { ForwardRef as ReactComponent };